import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Notification from './pages/Campaigns'
import Users from './pages/Users'
import Commerce from './pages/Commerce'
import Automation from './pages/Automation'
import Integration from './pages/Integration'
import Dropdown from './pages/CreateCampaign'
import Dashboard from './pages/Dashboard'
import BotWorkflow from './pages/Workflow/BotWorkflow'
import WorkflowManager from './pages/Workflow/WorkflowManager'
import TemplateForm from './pages/Template/TemplateForm/TemplateForm'
import WhatsappTemplateList from './pages/Template/TemplateList'
import TemplateLibrary from './pages/Template/TemplateLibrary'
import Segments from './pages/Segments'

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Dashboard />} />
    <Route path=":tenantName/dashboard" element={<Dashboard />} />
    <Route path=":tenantName/campaigns" element={<Notification />} />
    <Route path=":tenantName/campaign/create" element={<Dropdown />} />
    <Route path=":tenantName/users" element={<Users />} />
    <Route path=":tenantName/contacts/segment" element={<Segments />} />
    <Route path=":tenantName/templateForm" element={<TemplateForm />} />
    <Route path=":tenantName/templateList" element={<WhatsappTemplateList />} />
    <Route path=":tenantName/template-Library" element={<TemplateLibrary />} />
    <Route path=":tenantName/Bot-Workflow" element={<BotWorkflow />} />
    <Route path=":tenantName/Bot-Workflow-manage" element={<WorkflowManager />} />

    
    <Route path=":tenantName/commerce" element={<Commerce />} />
    <Route path=":tenantName/automation" element={<Automation />} />
    <Route path=":tenantName/integration" element={<Integration />} />
  </Routes>
)

export default AppRoutes
